export {
  getAttributeSelectors,
  getVariantAttrData,
  type AttrData,
  type AttributeSelector
} from './attribute-selector'
export * from './classes'
export { COLOR_PROPERTY, MAX_COLORS_PER_VIEW } from './color'
export { groupBy, productMapper, ProductProperties } from './group-by'
export {
  SORT_PARAM_KEY,
  sortItemsByPrice,
  sortItemsBySequenceNumber,
  sortVariantsBySequenceNumber,
  sortVariantsByStock
} from './sort'
export {
  getStockLevelStatus,
  STOCKS_CACHE_MAX_AGE,
  stockStatusMap,
  type Stocks
} from './stock'
export { getColorSelector } from './color-variants'
export { getFavourProfiles } from './flavour-profiles'
export { getPriceInfo } from './price-info'
export {
  showProduct,
  getEnabledFilters,
  filterHistoryByStash,
  getHistoryFromStash,
  getMatchedVariant,
  type FilterStashType,
  type EnabledFiltersType,
  type HistoryFilter
} from './filter'

export const scrollToElementWithOffset = (
  el: HTMLElement | null,
  offset = 0
) => {
  if (el) {
    const topPosition = el.getBoundingClientRect().top
    const offsetTopPosition = topPosition + window.scrollY - offset

    window.scrollTo({
      top: offsetTopPosition,
      behavior: 'smooth'
    })
  }
}
